import {cx} from "emotion";
import * as React from "react";

import "./thumbnails.scss";

import {ComponentLink, makeChain}   from "@Common/react/cst2";
import {Load2}                      from "@Common/react/load2";
import {chain}                      from "@Common/utils/fs";

import {consumeContext}         from "@Xpresso/loaders/consume-context";
import {TemplateSvgThumbnail}   from "@Xpresso/routes/common/components/template-svg-thumbnail/template-svg-thumbnail";

export const Thumbnails = ({images, onMore, maxThumbnailCount, startIndex, endIndex}:{
    endIndex            : number,
    images              : Array<{src: string, selected: boolean, onSelect: () => void}>,
    maxThumbnailCount   : number,
    onMore              : () => void,
    startIndex          : number,
}) => (
    <div className="thumbnails thumbnails-8op">
        {maxThumbnailCount > 0 && chain(
            images?.length <= maxThumbnailCount + 1 ? {
                images,
                moreCount: 0,
            } : {
                images: images?.slice(startIndex, endIndex+1),
                moreCount: images?.length - maxThumbnailCount,
            },
            ({images, moreCount}) => <>
                {images?.map((img, i) => (
                    <Thumbnail
                        key={i}
                        selected={img.selected}
                        src={img.src}
                        onSelect={img.onSelect}
                        xdQaName={`Back ${(i+1)}`}
                    />
                ))}

                {!!moreCount && (
                    <div className="more" onClick={onMore}>
                        <div className="text">
                            {moreCount} +
                        </div>
                    </div>
                )}
            </>
        )}
    </div>
);

const Thumbnail = ({selected, src, onSelect: emitSelect, xdQaName}:{
    onSelect   ?: () => void,
    selected    : boolean,
    src         : string,
    xdQaName   ?: string,
}) => (
    makeChain<JSX.Element>()
    .then(...consumeContext("svgThumbnailsCache"))
    .then("svgCodeLoad", ({svgThumbnailsCache: {loadUrl}}, next: ComponentLink<typeof Load2<string>>) => (
        Load2({next, fetch: () => src.endsWith(".svg") ? loadUrl(src) : null})
    ))
    .then(({svgCodeLoad: {value: svgCode}}) => (
        <div
            className={cx("img", {selected: selected})}
            style={!svgCode ? {backgroundImage: `url('${src}')`} : null}
            onClick={() => emitSelect()}
            xd-qa-type={"icon"}
            xd-qa-name={xdQaName}
        >
            {svgCode && <TemplateSvgThumbnail svgCode={svgCode}/>}
            {selected && (
                <div className="check">
                    <i className="fa fa-check"/>
                </div>
            )}
        </div>
    ))
    .run()
);

